import { Sprite, Container } from "pixi.js";

export class Obstacle {
  public x: number;
  public y: number;
  public width: number;
  public height: number;
  public radius: number;
  public sprite: Sprite;
  public over: Container;
  public under: Container;
  public type: ObstacleType;
  constructor(
    x: number,
    y: number,
    width: number,
    height: number,
    radius: number,
    sprite: Sprite,
    over: Container,
    under: Container,
    type: ObstacleType
  ) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.radius = radius;
    this.sprite = sprite;
    this.over = over;
    this.under = under;
    this.type = type;
  }

  reset() {
    this.x = 0;
    this.y = 0;
    this.width = 0;
    this.height = 0;
    this.radius = 0;
    this.sprite = null as any;
    this.over = null as any;
    this.under = null as any;
  }
}

export enum ObstacleType {
  BAGGAGE_1 = 0,
  BAGGAGE_2 = 1,
  BAGGAGE_3 = 2,
  RED_FLAG = 3,
  SIGN = 4,
  TEXT_1 = 5,
  TEXT_2 = 6,
  TREE = 7
}
